import { request, METHOD } from "@/utils/request";
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/** 询价单列表接口
 * @param {Object} data
 */
export function getInquiryList(data) {
  return request("".concat(BASE_URL) + "/ask/price/list", METHOD.POST, data);
}

/** 询价单详情接口
 * @param {Object} data
 */
export function getInquiryDetail(data) {
  return request("".concat(BASE_URL) + "/ask/price/children/allInfo", METHOD.GET, data);
}
export function getErpRequestPriceList(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/list", METHOD.POST, data);
}

/** 见绩书详情
 * @param {Object} data
 */
export function getQuoteDetailBasicInfos(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/main/".concat(data, "/basicInfos"), METHOD.GET);
}

/** 获取传票明细tab数据 #151
 * @param {Object} data
 */
export function getQuoteDetailProducts(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/children/allInfo", METHOD.GET, data);
}
export function syncQuote() {
  return request("".concat(BASE_URL) + "/erpTimerApi/syncOrderStatus", METHOD.GET);
}
export function getRequestPriceList(data) {
  return request("".concat(BASE_URL) + "/request/price/list", METHOD.POST, data);
}

/** 见绩书详情
 * @param {Object} data
 */
export function getRequestPriceDetailBasicInfos(data) {
  return request("".concat(BASE_URL) + "/request/price/main/".concat(data, "/basicInfos"), METHOD.GET);
}

/** 获取传票明细tab数据 #151
 * @param {Object} data
 */
export function getRequestPriceDetailProducts(data) {
  return request("".concat(BASE_URL) + "/request/price/children/allInfo", METHOD.GET, data);
}
/** 获取传票明细tab数据 #151
 * @param {Object} data
 */
export function getRequestPriceStatusList(data) {
  return request("".concat(BASE_URL) + "/request/price/status/list/" + data, METHOD.GET);
}
/** 手动同步见绩依赖状态
 * @param {Object} data
 */
export function syncRequestPriceStatus(data) {
  return request("".concat(BASE_URL) + "/erpTimerApi/syncRequestPriceStatus", METHOD.GET);
}

/** 手动同步见绩书
 * @param {Object} data
 */
export function syncErpRequestPrice(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/syncErpOrders", METHOD.GET);
}

/** 手动通知
 * @param {Object} data
 */
export function erpRquestPricenotify(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/".concat(data, "/notify"), METHOD.GET);
}

/** 通知履历
 * @param {Object} data
 */
export function getErpRequsstPriceNotifyList(data) {
  return request("".concat(BASE_URL) + "/erp/request/price/notifyVersion/".concat(data), METHOD.GET);
}